export class UploadPersonalImage
{
    constructor()
        {
            this.English = "Upload Personal Image";
            this.Arabic = "تحميل صورة الشخصية";
        }
    English:string 
    Arabic:string 
}